import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', loadChildren: () => import('./main/main.module').then(m => m.MainModule) }, 
  { path: 'admin', loadChildren: () => import('./admin-cms/admin-cms.module').then(m => m.AdminModule) }];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled', // Disable default scroll restoration
      anchorScrolling: 'enabled',   
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
